import GridIcon from '../../assets/icons/sidebar/grid.svg'
import User1Icon from '../../assets/icons/sidebar/users-1.svg'
// import User2Icon from '../../assets/icons/sidebar/user-2.svg'
import TicketIcon from '../../assets/icons/sidebar/ticket.svg'
import FileIcon from '../../assets/icons/sidebar/file.svg'
import PuzzleIcon from '../../assets/icons/sidebar/puzzle-piece.svg'
import CalendarIcon from '../../assets/icons/sidebar/calendar-minus.svg'
import SettingsIcon from '../../assets/icons/sidebar/settings.svg'
// import HelpIcon from '../../assets/icons/sidebar/help-circle.svg'
// import AlertIcon from '../../assets/icons/sidebar/alert-triangle.svg'
// import LogoutIcon from '../../assets/icons/sidebar/log-out.svg'

import GridWhiteIcon from '../../assets/icons/sidebar/grid-white.svg'
import User1WhiteIcon from '../../assets/icons/sidebar/users-1-white.svg'
// import User2WhiteIcon from '../../assets/icons/sidebar/user-2-white.svg'
import TicketWhiteIcon from '../../assets/icons/sidebar/ticket-white.svg'
import FileWhiteIcon from '../../assets/icons/sidebar/file-white.svg'
import PuzzleWhiteIcon from '../../assets/icons/sidebar/puzzle-piece-white.svg'
import CalendarWhiteIcon from '../../assets/icons/sidebar/calendar-minus-white.svg'
import SettingsWhiteIcon from '../../assets/icons/sidebar/settings-white.svg'
import { USER_ROLES } from '../../utils/userRole'

export const SIDEBAR_ITEMS = [
  {
    name: 'Overview',
    icon: { white: GridWhiteIcon, black: GridIcon },
    route: '/overview',
    permission: [USER_ROLES.ADMIN],
    relativeMatchPaths: [],
  },
  {
    name: 'Customer',
    icon: { white: User1WhiteIcon, black: User1Icon },
    route: '/customer',
    permission: [USER_ROLES.ADMIN],
    relativeMatchPaths: ['customer', 'customer/create', 'customer/edit/:id', 'customer/details'],
  },
  {
    name: 'Ticket',
    icon: { white: TicketWhiteIcon, black: TicketIcon },
    route: '/ticket',
    permission: [USER_ROLES.ADMIN, USER_ROLES.USER],
    relativeMatchPaths: ['ticket', 'ticket/create', 'ticket/edit/:id', 'ticket/details/:id'],
  },
  {
    name: 'Invoice',
    icon: { white: FileWhiteIcon, black: FileIcon },
    route: '/Invoice',
    permission: [USER_ROLES.ADMIN, USER_ROLES.USER],
  },
  {
    name: 'Assets',
    icon: { white: PuzzleWhiteIcon, black: PuzzleIcon },
    route: '/assets',
    permission: [USER_ROLES.ADMIN],
    relativeMatchPaths: ['assets', 'assets/create', 'assets/edit/:id', 'assets/details/:id'],
  },
  // {
  //   name: 'Admin',
  //   icon: { white: User2WhiteIcon, black: User2Icon },
  //   route: '/admin',
  //   permission: [USER_ROLES.ADMIN],
  // },
  {
    name: 'Appointment',
    icon: { white: CalendarWhiteIcon, black: CalendarIcon },
    route: '/appointments',
    permission: [USER_ROLES.ADMIN, USER_ROLES.USER],
    relativeMatchPaths: ['appointments', 'appointment/create', 'appointment/edit/:id', 'appointment/details/:id'],
  },
  {
    name: 'Settings',
    icon: { white: SettingsWhiteIcon, black: SettingsIcon },
    route: null,
    permission: [USER_ROLES.ADMIN],
  },
  // {
  //   name: 'Message',
  //   icon: { white: SettingsWhiteIcon, black: SettingsIcon },
  //   route: '/communications',
  //   permission: [USER_ROLES.USER],
  // },
]
